import React from 'react'
import CFPurpleLogo from 'url:./assets/Logo_purple_transparent_BG.png'

function PoweredBy () {
  return (
    <div className='powered-by' onClick={() => window.open('https://getsignals.ai/', '_blank')}>
      <img src={CFPurpleLogo} height={25} width={25} />
      <p>Powered by Signals</p>
    </div>
  )
}

export default PoweredBy
